import {MutationTree} from "vuex";
import SupplierInterface from "../ts/SupplierInterface";

export const mutations: MutationTree<any> = {

    setSuppliers(state: any, payload: Array<SupplierInterface>) {
        state.suppliers = payload;
    },

    createSupplier(state: any, supplier: SupplierInterface) {
        state.suppliers.push(supplier);
    },

    updateSupplier(state: any, supplier: SupplierInterface) {
        const index = state.suppliers.findIndex((s: SupplierInterface) => s.id === supplier.id);
        if (index!==null) state.suppliers.splice(index,1, supplier);
    },

    deleteSupplier(state: any, supplier: SupplierInterface) {
        const index = state.suppliers.findIndex((s: SupplierInterface) => s.id === supplier.id);
        if (index!==null) state.suppliers.splice(index, 1);
    }
}